
let websocket;
let closeAndReopen;
var websoketForSafari = function (worker) {
  let wsuri = "";
  //心跳触发最小间隔300;
  let duration = 300;
  let validSend = true;
  let loadMount = 0;
  let loadTimer = null;

  //待优化
  function throttleSend(fn, delay) {
    if (!validSend) {
      return false;
    }
    validSend = false;
    setTimeout(() => {
      fn();
      validSend = true;
    }, delay);
  }

  var initSocket = function (port, wsuri) {
    console.log("================",wsuri)
    if (websocket) return;

    websocket = new WebSocket(wsuri);
    websocket.binaryType = "arraybuffer";
    //websoket打开

    websocket.onopen = function (event) {
      worker.port.postMessage({ method: "heartcheck" })
      //console,log("打开webcoket");
      // //console,log(websocket);
      worker.port.postMessage({ method: "websocketonopen", eventData: { ...event } });
    };
    //websoket抛错
    websocket.onerror = function (event) {
      //console,log("webcoket报错");
      closeAndReopen();
      //port.postMessage({method:"websocketonerror",eventData: {...event}});
    };

    websocket.onmessage = function (event) {
      //重置loadMount次数
      loadMount = 0;
      //console,log("收到push消息开始");
      let bytes = new Uint8Array(event.data)
      worker.port.postMessage({ method: "heartcheck" });
      worker.port.postMessage({ method: "websocketonmessage", eventData: { data: bytes } });
    };

    websocket.onclose = function (event) {
      //console,log("webcoket关闭");
      closeAndReopen();
      //port.postMessage({method:"websocketclose",eventData: {...event}})
    };
  };

  /*CONNECTING：值为0，表示正在连接；
OPEN：值为1，表示连接成功，可以通信了；
CLOSING：值为2，表示连接正在关闭；
CLOSED：值为3，表示连接已经关闭，或者打开连接失败*/
  function sendSocket(data) {
    throttleSend(function () {
      if (websocket.readyState != websocket.OPEN) {
        //console,log(`websocket断开并开始主动重连`);
        if (websocket) websocket.close();
        websocket = null;
      } else {
        //console,log(`websocket发送信息`);
        websocket.send(data);
      }
    }, duration);
  }

  function closeSocket() {
    //console,log("关闭websoket")
    websocket.close();
    websocket = null;
  }

  closeAndReopen = () =>{
    if (loadTimer) return;
    loadTimer = setTimeout(() => {
      loadTimer = clearTimeout(loadMount);
      loadMount++;
      if (websocket) websocket.close();
      websocket = null;
      initSocket(worker.port, wsuri);
    }, loadMount < 5 ? 2000 : 10000)
  }

  worker.port.onmessage = function (event) {
    switch (event.data.method) {
      case "init":
        wsuri = event.data.url;
        initSocket(worker.port, event.data.url);
        break;
      case "close":
        closeSocket();
        break;
      case "send":
        sendSocket(event.data.data);
        break;
    }
  }
}

export const lookupWebsoketAndReconnect = ()=> {
  //查看websoket连接状态"  3为已关闭
  if(websocket && websocket.readyState ==3){
    closeAndReopen()
  }
}

let isLostFocus = false;
if(process.browser){
  window.addEventListener('visibilitychange', function() {
    if (document['hidden']){
      // 失去焦点
      isLostFocus = true;
    } else {
      // 获取焦点
      console.log("获取焦点")
      if(isLostFocus)lookupWebsoketAndReconnect();
      isLostFocus = false;
    }
  });
}

export default websoketForSafari;
